import React, { useState } from 'react'

import { TbRewindForward50 } from "react-icons/tb";
import { TbRewindBackward50 } from "react-icons/tb";
import { MdCurrencyRupee } from "react-icons/md";
import { GiSofa } from "react-icons/gi";
import { FaBuildingLock } from "react-icons/fa6";
import { FaBusinessTime } from "react-icons/fa";

import heroImg from '../../../../assets/bhutani/Office/officeHero.webp'
import inner1 from '../../../../assets/bhutani/Office/office-1.png'
import inner2 from '../../../../assets/bhutani/Office/office-2.jpg'
import inner3 from '../../../../assets/bhutani/Office/office-3.jpg'
import inner4 from '../../../../assets/bhutani/Office/office-4.jpg'
import inner5 from '../../../../assets/bhutani/Office/office-5.jpg'

import { ImageModal } from '../../../common/ImageModal';
import { ConnectForm } from '../../../common/ConnectForm';

const GreenOffice = () => {
    const [openImgModal, setOpenImgModal] = useState(false)
    const innerImgs = [inner1, inner2, inner3, inner4, inner5]
    const points = [
        {
            icon: FaBuildingLock,
            title: 'Lockable Office Space (250 sqft))',
        },
        {
            icon: GiSofa,
            title: 'fully furnished Oxirich office',
        },
        {
            icon: FaBusinessTime,
            title: 'Possession approx 12 months',
        },
        {
            icon: MdCurrencyRupee,
            title: 'Payment Plan- 50:50',
        },
        {
            icon: TbRewindForward50,
            title: ' 50% on Booking',
        },
        {
            icon: TbRewindBackward50,
            title: '50% in 18 Months',
        },
    ];


    return (
        <div className="w-full min-h-screen bg-gray-100">
            <div
                className="w-full h-[500px] bg-cover bg-center mb-5"
                style={{ backgroundImage: `url('${heroImg}')` }}
            ></div>

            <div class="flex flex-col md:flex-row px-2.5 gap-4">
                <div class="w-full md:w-2/3 flex flex-col gap-4">
                    <div class="">
                        <div className="max-w-5xl mx-auto p-6">
                            <p className="text-md text-gray-700 mb-4 text-justify"> The Luxury Green Office Spaces at Bhutani City Center 32 in Noida Sector 32 are designed to redefine the modern
                                workspace. These office spaces are part of a revolutionary concept that seamlessly combines luxury, functionality,
                                and wellness. </p>
                            <p className="text-md text-gray-700 mb-4 text-justify">Breathe Easy, Work Smarter : The office spaces feature cutting-edge air quality technology, ensuring an unmatched
                                Air Quality Index (AQI) that provides clean, fresh air for you and your team.</p>
                            <p className="text-md text-gray-700 mb-4 text-justify">Fully Furnished, Ready to Go : Each office space is fully furnished with modern, comfortable, and professional
                                settings. From workstations to state-of-the-art technology, every detail is meticulously crafted to provide a seamless
                                working experience.</p>
                            <p className="text-md text-gray-700 mb-4 text-justify"> Wellness at the Core : Designed with wellness in mind, these office spaces combine productivity with a focus on
                                mental and physical health. Natural light, clean air, and modern design create an environment where you can work
                                without compromise, maintaining a balance of work and well-being.</p>
                            <p className="text-md text-gray-700 mb-4 text-justify">  Located in the heart of Noida Sector 32, Bhutani City Center 32 offers excellent connectivity and accessibility, making
                                it a prime destination for businesses looking to thrive in a vibrant commercial atmosphere.</p>
                        </div>
                        <div className="max-w-4xl mx-auto p-6">
                            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                                {points.map((point, index) => (
                                    <div
                                        key={index}
                                        className="flex items-center bg-white p-4 rounded-lg shadow hover:shadow-lg transition-shadow duration-300"
                                    >
                                        {React.createElement(point.icon, {
                                            size: 24,
                                            color: "green",
                                            className: "w-6 h-6 mr-3",
                                        })}
                                        <span className="text-gray-700 font-medium">{point.title}</span>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
                <ConnectForm />
            </div>

            {openImgModal && (
                <ImageModal images={innerImgs} openImg={openImgModal} />
            )}
            <div className="max-w-7xl mx-auto grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-6 p-4">
                {innerImgs.map((data, index) => (
                    <div
                        key={index}
                        onClick={() => setOpenImgModal(true)}
                        className="w-full h-full rounded-md shadow-md overflow-hidden bg-white object-cover transition-transform duration-300 transform hover:scale-105"
                        >
                        <img src={data} alt="Bhutani" className="w-full h-full object-cover" />
                    </div>
                ))}
            </div>

        </div>
    )
}
export default GreenOffice;